/* Theme JS — gallery, bundle tiers, add-ons, sticky bar */
(function () {
  var money = function (cents, fmt) {
    var v = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (fmt || '${{amount}}').replace(/\{\{\s*amount\s*\}\}/, v);
  };

  /* ---- Gallery ---- */
  document.querySelectorAll('[data-gallery]').forEach(function (g) {
    var main = g.querySelector('[data-gallery-main]');
    g.querySelectorAll('[data-gallery-thumb]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (main) main.src = b.dataset.full;
        g.querySelectorAll('[data-gallery-thumb]').forEach(function (o) {
          o.setAttribute('aria-current', o === b ? 'true' : 'false');
        });
      });
    });
  });

  /* ---- Bundle + add-ons ---- */
  document.querySelectorAll('[data-buybox]').forEach(function (box) {
    var fmt = box.dataset.moneyFormat;
    var unit = parseInt(box.dataset.unitPrice, 10) || 0;
    var compare = parseInt(box.dataset.comparePrice, 10) || 0;
    var qtyInput = box.querySelector('[data-qty]');
    var now = box.querySelector('[data-price-now]');
    var was = box.querySelector('[data-price-was]');
    var save = box.querySelector('[data-price-save]');

    function selectedTier() {
      return box.querySelector('[data-tier]:checked');
    }
    function addonTotal() {
      var t = 0;
      box.querySelectorAll('[data-addon]:checked').forEach(function (a) {
        t += parseInt(a.dataset.price, 10) || 0;
      });
      return t;
    }
    function render() {
      var tier = selectedTier();
      if (!tier) return;
      var qty = parseInt(tier.dataset.qty, 10) || 1;
      var pct = parseFloat(tier.dataset.discount) || 0;
      var subtotal = Math.round(unit * qty * (1 - pct / 100)) + addonTotal();
      var full = (compare > unit ? compare : unit) * qty + addonTotal();
      if (qtyInput) qtyInput.value = qty;
      if (now) now.textContent = money(subtotal, fmt);
      if (was) {
        was.textContent = full > subtotal ? money(full, fmt) : '';
        was.style.display = full > subtotal ? '' : 'none';
      }
      if (save) {
        var pctOff = full > subtotal ? Math.round(((full - subtotal) / full) * 100) : 0;
        save.textContent = pctOff ? 'SAVE ' + pctOff + '%' : '';
        save.style.display = pctOff ? '' : 'none';
      }
      box.querySelectorAll('[data-addon]').forEach(function (a) {
        var prop = box.querySelector('[data-addon-prop="' + a.dataset.addon + '"]');
        if (prop) prop.disabled = !a.checked;
      });
    }
    box.addEventListener('change', render);
    render();
  });

  /* ---- Sticky add-to-cart ---- */
  var sticky = document.querySelector('[data-sticky]');
  var anchor = document.querySelector('[data-sticky-anchor]');
  if (sticky && anchor && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      sticky.classList.toggle('is-on', !entries[0].isIntersecting);
    }, { rootMargin: '0px 0px -80% 0px' }).observe(anchor);
    sticky.querySelectorAll('[data-sticky-submit]').forEach(function (b) {
      b.addEventListener('click', function () {
        var f = document.querySelector('[data-buybox] form');
        if (f) f.requestSubmit ? f.requestSubmit() : f.submit();
      });
    });
  }
})();

/* Add-on line items: submit main item + selected add-ons together */
(function () {
  var form = document.getElementById('buybox-form');
  if (!form) return;
  form.addEventListener('submit', function (e) {
    var box = form.closest('[data-buybox]') || document;
    var addons = Array.prototype.slice.call(box.querySelectorAll('[data-addon]:checked'))
      .filter(function (a) { return a.dataset.variant; });
    if (!addons.length) return; // normal POST
    e.preventDefault();
    var items = [{
      id: form.querySelector('[name="id"]').value,
      quantity: parseInt(form.querySelector('[data-qty]').value, 10) || 1
    }];
    addons.forEach(function (a) { items.push({ id: a.dataset.variant, quantity: 1 }); });
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function () { window.location.href = '/cart'; });
  });
})();
